<!-- src/views/auth/Register.vue -->
<template>
  <div class="authentication-wrapper authentication-basic container-p-y">
    <div class="authentication-inner">
      <div class="card">
        <div class="card-body">
          <!-- Logo -->
          <div class="app-brand justify-content-center">
            <span class="app-brand-text demo text-body fw-bold">{{ appName }}</span>
          </div>

          <h4 class="mb-2">Adventure starts here 🚀</h4>
          <p class="mb-4">Make your app management easy and fun!</p>

          <form @submit.prevent="handleRegister">
            <div class="mb-3">
              <label for="name" class="form-label">Full Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="form.name"
                :class="{ 'is-invalid': errors.name }"
                placeholder="Enter your full name"
                autofocus
                required
              />
              <div class="invalid-feedback" v-if="errors.name">
                {{ errors.name }}
              </div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                id="email"
                v-model="form.email"
                :class="{ 'is-invalid': errors.email }"
                placeholder="Enter your email"
                required
              />
              <div class="invalid-feedback" v-if="errors.email">
                {{ errors.email }}
              </div>
            </div>

            <div class="mb-3 form-password-toggle">
              <label class="form-label" for="password">Password</label>
              <div class="input-group input-group-merge">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-control"
                  v-model="form.password"
                  :class="{ 'is-invalid': errors.password }"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showPassword = !showPassword">
                  <i class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </span>
                <div class="invalid-feedback" v-if="errors.password">
                  {{ errors.password }}
                </div>
              </div>
            </div>

            <div class="mb-3 form-password-toggle">
              <label class="form-label" for="password_confirmation">Confirm Password</label>
              <div class="input-group input-group-merge">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  id="password_confirmation"
                  class="form-control"
                  v-model="form.password_confirmation"
                  :class="{ 'is-invalid': errors.password_confirmation }"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showConfirmPassword = !showConfirmPassword">
                  <i class="bi" :class="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </span>
                <div class="invalid-feedback" v-if="errors.password_confirmation">
                  {{ errors.password_confirmation }}
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="terms" v-model="form.terms" required />
                <label class="form-check-label" for="terms">
                  I agree to
                  <a href="#" class="text-primary">privacy policy & terms</a>
                </label>
              </div>
            </div>

            <div class="mb-3">
              <button class="btn btn-primary d-grid w-100" type="submit" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                {{ loading ? 'Creating account...' : 'Sign up' }}
              </button>
            </div>
          </form>

          <p class="text-center">
            <span>Already have an account?</span>
            <router-link to="/login">
              <span>Sign in instead</span>
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Register',

  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        terms: false
      },
      showPassword: false,
      showConfirmPassword: false,
      errors: {}
    }
  },

  computed: {
    ...mapGetters('auth', ['loading', 'error']),

    appName() {
      return process.env.VUE_APP_NAME || 'EDCTP Admin'
    }
  },

  methods: {
    ...mapActions('auth', ['register']),

    async handleRegister() {
      this.errors = {}

      try {
        await this.register(this.form)
        this.$router.push('/my-profile')
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        }
      }
    }
  }
}
</script>

<style scoped>
.authentication-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
}

.authentication-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.card {
  box-shadow: 0 0.25rem 1rem rgba(161, 172, 184, 0.45);
  border: 0;
}

.app-brand {
  margin-bottom: 1.5rem;
}

.app-brand-text {
  color: #009CAD;
  font-size: var(--font-size-xl);
}

.cursor-pointer {
  cursor: pointer;
}

.form-password-toggle .input-group-text:hover {
  background-color: #f8f9fa;
}
</style>
